// extracted by mini-css-extract-plugin
export var active = "_dv-7";
export var blink = "_dv-8";
export var dropDownSelector = "_dv-4";
export var dropDownWrapper = "_dv-3";
export var fakeCursor = "_dv-6";
export var fontSizeButton = "_dv-9";
export var formQuillEditor = "_dv-0";
export var pressed = "_dv-a";
export var qlBlank = "_dv-1";
export var textFormattingToolbar = "_dv-2";
export var textToolbarOption = "_dv-5";